module.exports = __webpack_public_path__ + "static/manpowergroup-e928da324b03a6cca33d084238fe0864.svg";